// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WgaW","colBig":"styles_colBig__yKKg6","colSmall":"styles_colSmall__BO7j6","shopifyNameWrapper":"styles_shopifyNameWrapper__24oLm"};